interface IExtraField {
    type: string;
    name: string;
    defaultValue?: string;
    data?: any[];
}

interface IEmailMap {
    [key: string]:
        | {
              type: 'klaviyo';
              list_id: string;
              source: string;
              consent_form_id: string;
              popupBtnLink: string;
          }
        | {
              type: 'mailchimp';
              action: string;
              extraFields?: IExtraField[];
              popupBtnLink: string;
          };
}

export const emailMap: IEmailMap = {
    us: {
        type: 'mailchimp',
        action: 'https://ecoflow.us19.list-manage.com/subscribe/post?u=80218c17c3ffb8d06454fa749&id=e15592488f&f_id=00d78de4f0',
        popupBtnLink: 'https://us.ecoflow.com/pages/river-2-referral-program',
    },
    za: {
        type: 'mailchimp',
        action: 'https://ecoflow.us19.list-manage.com/subscribe/post?u=80218c17c3ffb8d06454fa749&amp;id=c888d88eed&amp;f_id=00fa92e4f0',
        popupBtnLink: 'https://www.facebook.com/groups/efsouthafrica',
    },
    au: {
        type: 'mailchimp',
        action: 'https://ecoflow.us19.list-manage.com/subscribe/post?u=80218c17c3ffb8d06454fa749&amp;id=a225940be3&amp;f_id=00e292e4f0',
        popupBtnLink: 'https://www.facebook.com/groups/efaustralia',
    },
    ca: {
        type: 'klaviyo',
        list_id: 'VsWT3k',
        source: 'RIVER 2 Newsletter List',
        consent_form_id: 'TfnHMT',
        popupBtnLink: 'https://ca.ecoflow.com/pages/river-2-referral-program',
    },
    uk: {
        type: 'klaviyo',
        list_id: 'TQM6TJ',
        source: 'RIVER 2 Teaser form',
        consent_form_id: 'SruuXG',
        popupBtnLink: 'https://uk.ecoflow.com/pages/river-2-referral-program',
    },
    eu: {
        type: 'mailchimp',
        action: 'https://ecoflow.us19.list-manage.com/subscribe/post?u=80218c17c3ffb8d06454fa749&id=c05c23979e&f_id=00df8de4f0',
        extraFields: [
            {
                type: 'select',
                name: 'COUNTRY',
                data: [
                    'Andorra',
                    'Angola',
                    'Armenia',
                    'Austria',
                    'Belarus',
                    'Belgium',
                    'Bulgaria',
                    'Croatia',
                    'Cyprus',
                    'Czech Republic',
                    'Denmark',
                    'Estonia',
                    'Finland',
                    'France',
                    'Germany',
                    'Greece',
                    'Ireland',
                    'Latvia',
                    'Liechtenstein',
                    'Lithuania',
                    'Luxembourg',
                    'Macedonia',
                    'Monaco',
                    'Norway',
                    'Poland',
                    'Portugal',
                    'Republic of Kosovo',
                    'Romania',
                    'Russia',
                    'Serbia',
                    'Slovakia',
                    'Slovenia',
                    'Spain',
                    'Sweden',
                    'Switzerland',
                    'Turkey',
                    'Ukraine',
                    'United Kingdom',
                    'Vatican City State (Holy See)',
                    'Other',
                ],
            },
        ],
        popupBtnLink: 'https://eu.ecoflow.com/pages/river-2-referral-program',
    },
    de: {
        type: 'mailchimp',
        action: 'https://ecoflow.us19.list-manage.com/subscribe/post?u=80218c17c3ffb8d06454fa749&id=c05c23979e&f_id=00df8de4f0',
        extraFields: [{ type: 'hidden_input', name: 'COUNTRY', defaultValue: 'Germany' }],
        popupBtnLink: 'https://de.ecoflow.com/pages/river-2-referral-program',
    },
    fr: {
        type: 'mailchimp',
        action: 'https://ecoflow.us19.list-manage.com/subscribe/post?u=80218c17c3ffb8d06454fa749&id=c05c23979e&f_id=00df8de4f0',
        extraFields: [{ type: 'hidden_input', name: 'COUNTRY', defaultValue: 'France' }],
        popupBtnLink: 'https://fr.ecoflow.com/pages/river-2-referral-program',
    },
    it: {
        type: 'mailchimp',
        action: 'https://ecoflow.us19.list-manage.com/subscribe/post?u=80218c17c3ffb8d06454fa749&id=c05c23979e&f_id=00df8de4f0',
        extraFields: [{ type: 'hidden_input', name: 'COUNTRY', defaultValue: 'Italy' }],
        popupBtnLink: 'https://it.ecoflow.com/pages/river-2-referral-program',
    },
    es: {
        type: 'mailchimp',
        action: 'https://ecoflow.us19.list-manage.com/subscribe/post?u=80218c17c3ffb8d06454fa749&id=c05c23979e&f_id=00df8de4f0',
        extraFields: [{ type: 'hidden_input', name: 'COUNTRY', defaultValue: 'Spain' }],
        popupBtnLink: 'https://es.ecoflow.com/pages/river-2-referral-program',
    },
    jp: {
        type: 'mailchimp',
        action: 'https://ecoflow.us8.list-manage.com/subscribe/post?u=d002bf04842356c4c1c5221cf&amp;id=c391b15388&amp;f_id=009e72e1f0',
        popupBtnLink: 'https://jp.ecoflow.com/pages/river-2-referral-program',
    },
};
